import { FC, useState } from "react";
import { Tabs, Tab, Table } from "react-bootstrap";
import Modal from "../../common/components/ThemedModal";
import { LuDot } from "react-icons/lu";
import { MdFormatListNumbered } from "react-icons/md";
import UCI_POINTS from "../../../assets/UCI_POINTS_2025.png";

interface PointsData {
	[key: string]: {
		q: string | number;
		s: string | number;
		f: string | number;
	};
}

interface TeamPointsData {
	Position: number;
	Points: number;
}

interface UCIPointsModalProps {
	viewScoring: boolean;
	setViewScoring: (value: boolean) => void;
	uciTeamPoints: TeamPointsData[];
}

const UCIPointsModal: FC<UCIPointsModalProps> = ({
	viewScoring,
	setViewScoring,
	uciTeamPoints,
}) => {
	return (
		<Modal
			show={viewScoring}
			onHide={() => setViewScoring(false)}
			size="lg"
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title>
					<b>UCI Downhill</b> <LuDot className="mb-1 me-2" />
					Rider Points
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="px-md-5">
				<Tabs
					defaultActiveKey="riders"
					id="uncontrolled-tab-example"
					className="mb-3"
				>
					<Tab eventKey="riders" title="Riders" style={{ overflow: "auto" }}>
						<div className="mb-3">
							<p>
								UCI points distribution for Downhill competitions. For more
								details, check the official
								<a
									href="https://assets.ctfassets.net/761l7gh5x5an/GyPIqfNoG0ZltmczdulzU/7fcac0bfa3af6be99ae5e2ac84d6595a/UCI_MTB_Rules_-_Part_IV_-_ENG.pdf"
									target="_blank"
									rel="noreferrer"
									className="ms-1"
								>
									UCI MTB Rules document
								</a>
								.
							</p>
							<div className="text-center">
								<img
									src={UCI_POINTS}
									alt="UCI Points Table"
									className="img-fluid"
									style={{ maxWidth: "100%" }}
								/>
							</div>
						</div>
					</Tab>
					<Tab eventKey={"team"} title="Team" style={{ overflow: "auto" }}>
						<div className="mb-3 fst-italic" style={{ fontSize: "0.8rem" }}>
							{" "}
							** Please note that team points have be created and calculated by
							The Race Companion and in no way reflect official UCI Team Points.{" "}
						</div>
						<Table striped bordered hover>
							<thead>
								<tr>
									<th>
										<MdFormatListNumbered />
									</th>
									<th>Points</th>
								</tr>
							</thead>
							<tbody>
								{uciTeamPoints.map((team) => (
									<tr key={team.Position}>
										<td>{team.Position}.</td>
										<td>{team.Points}</td>
									</tr>
								))}
							</tbody>
						</Table>
					</Tab>
				</Tabs>
			</Modal.Body>
		</Modal>
	);
};

export default UCIPointsModal;
